module.exports = __webpack_public_path__ + "static/media/bird.87f19446.jpg";